import serve from './modules/serve'
import global from './modules/global'
import Images from '@/assets'
import constant from './constant/index'
export default {
    constant,
    ...global,
    ...serve,
    ...Images,
}